export default __webpack_public_path__ + "static/media/turkey.c68123f7.jpg";